import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { getSettings } from "apis/controllers/common";
import background from "assets/images/login-background.png";
import {
  LandingProgramInfo2025,
  LandingProgramInfo2026,
  ProgramInfoYearSwitch,
  useProgramInfoYear,
} from "pages/ProgramInfo/ProgramInfoContent";
import UnderConstruction from "pages/UnderConstruction";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { programInfoYear, isProgramInfo2026, setProgramInfoYear } =
    useProgramInfoYear();

  const handleCitizenLogin = () => {
    navigate("/pubnr/login");
  };

  const handleEmployeeLogin = () => {
    navigate("/govnr/login");
  };

  const fetchSettings = async () => {
    try {
      const res = await getSettings();
      const getValue = (key) =>
        res.data.find((d) => d.dataKey === key)?.dataValue;
      setSettings({
        project_pubnr_login_enabled:
          getValue("project_pubnr_login_enabled") === "true",
        project_under_construction:
          getValue("project_under_construction") === "true",
        project_pubnr_login_disabled_msg: getValue(
          "project_pubnr_login_disabled_msg"
        ),
        project_under_construction_msg: getValue(
          "project_under_construction_msg"
        ),
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (window.location.pathname === "/lae-miteres") {
      window.history.replaceState({}, "", "/lae-miteres/");
    }
    fetchSettings();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const programInfoSwitch = (
    <ProgramInfoYearSwitch
      value={programInfoYear}
      onChange={setProgramInfoYear}
    />
  );

  return settings?.project_under_construction ? (
    <UnderConstruction msg={settings?.project_under_construction_msg} />
  ) : (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "70vh",
        width: "100%",
        marginTop: "-18px",
      }}
    >
      <div className="landing-content">
        {isProgramInfo2026 ? (
          <LandingProgramInfo2026 yearSwitch={programInfoSwitch} />
        ) : (
          <LandingProgramInfo2025 yearSwitch={programInfoSwitch} />
        )}

        <div className="landing-buttons">
          <Tooltip title={settings?.project_pubnr_login_disabled_msg || ""}>
            <span>
              <Button
                variant="contained"
                disabled={!settings?.project_pubnr_login_enabled}
                color="primary"
                size="large"
                onClick={handleCitizenLogin}
                sx={{
                  fontWeight: "bold",
                  fontSize: 19,
                  padding: "9px 22px",
                  height: "42px",
                  lineHeight: 1,
                }}
              >
                Είσοδος για πολίτες
              </Button>
            </span>
          </Tooltip>
          <Button
            size="large"
            sx={{ marginBottom: 2, marginLeft: "auto" }}
            variant="contained"
            color="info"
            onClick={handleEmployeeLogin}
          >
            Είσοδος για Υπαλλήλους
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
